export interface Category {
  id: string;
  nameKey: string;
  url: string;
  icon: string;
  image: string;
}

export const mainSiteUrl = 'https://kaspreadsheet.com';

export const categories: Category[] = [
  {
    id: 'shoes',
    nameKey: 'categories.shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=A%20pair%20of%20clean%20minimalist%20white%20leather%20sneakers%20on%20a%20soft%20warm%20beige%20studio%20background%20with%20subtle%20natural%20shadow%20and%20gentle%20window%20light%20editorial%20product%20photography%20simple%20backdrop%20high%20detail&width=600&height=600&seq=usfans-cat-shoes-02&orientation=squarish&nocache=true',
  },
  {
    id: 'hoodies',
    nameKey: 'categories.hoodies',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20cozy%20oatmeal%20hoodie%20sweater%20on%20a%20clean%20light%20cream%20studio%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadow%20editorial%20product%20photography%20simple%20minimal%20backdrop%20high%20detail&width=600&height=600&seq=usfans-cat-hoodies-02&orientation=squarish&nocache=true',
  },
  {
    id: 'tshirts',
    nameKey: 'categories.tshirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=A%20single%20soft%20sage%20green%20cotton%20t-shirt%20neatly%20folded%20on%20a%20bright%20white%20studio%20background%20with%20gentle%20natural%20light%20and%20faint%20shadow%20editorial%20minimal%20product%20photography%20simple%20clean%20backdrop%20high%20detail&width=600&height=600&seq=usfans-cat-tshirts-01&orientation=squarish',
  },
  {
    id: 'jackets',
    nameKey: 'categories.jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20camel%20toned%20bomber%20jacket%20displayed%20on%20a%20clean%20light%20beige%20studio%20surface%20with%20soft%20natural%20daylight%20and%20subtle%20shadow%20editorial%20minimal%20product%20photography%20simple%20backdrop%20high%20detail&width=600&height=600&seq=usfans-cat-jackets-01&orientation=squarish',
  },
  {
    id: 'pants',
    nameKey: 'categories.pants',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=A%20folded%20pair%20of%20casual%20khaki%20chino%20pants%20and%20light%20denim%20shorts%20stacked%20neatly%20on%20a%20clean%20white%20studio%20background%20with%20soft%20natural%20light%20and%20gentle%20shadow%20editorial%20minimal%20product%20photography%20high%20detail&width=600&height=600&seq=usfans-cat-pants-01&orientation=squarish',
  },
  {
    id: 'headwear',
    nameKey: 'categories.headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-store-line',
    image: 'https://readdy.ai/api/search-image?query=A%20single%20minimalist%20neutral%20tone%20baseball%20cap%20and%20a%20soft%20knit%20beanie%20arranged%20on%20a%20clean%20cream%20studio%20background%20with%20gentle%20natural%20light%20and%20subtle%20shadow%20editorial%20product%20photography%20simple%20backdrop%20high%20detail&width=600&height=600&seq=usfans-cat-headwear-01&orientation=squarish',
  },
  {
    id: 'sets',
    nameKey: 'categories.sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-gift-line',
    image: 'https://readdy.ai/api/search-image?query=A%20coordinated%20matching%20outfit%20set%20of%20a%20folded%20hoodie%20and%20sweatpants%20in%20soft%20grey%20neatly%20displayed%20on%20a%20clean%20white%20studio%20background%20with%20gentle%20natural%20light%20editorial%20minimal%20product%20photography%20high%20detail&width=600&height=600&seq=usfans-cat-sets-01&orientation=squarish',
  },
  {
    id: 'underwear',
    nameKey: 'categories.underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-heart-line',
    image: 'https://readdy.ai/api/search-image?query=Soft%20folded%20cotton%20underwear%20basics%20in%20neutral%20white%20and%20grey%20tones%20arranged%20on%20a%20clean%20light%20beige%20studio%20surface%20with%20gentle%20natural%20light%20and%20soft%20shadow%20editorial%20minimal%20product%20photography%20high%20detail&width=600&height=600&seq=usfans-cat-underwear-01&orientation=squarish',
  },
  {
    id: 'jersey',
    nameKey: 'categories.jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-award-line',
    image: 'https://readdy.ai/api/search-image?query=A%20neatly%20folded%20deep%20green%20sports%20jersey%20with%20subtle%20team%20style%20design%20displayed%20on%20a%20clean%20bright%20white%20studio%20background%20with%20soft%20natural%20light%20and%20gentle%20shadow%20editorial%20minimal%20product%20photography%20high%20detail&width=600&height=600&seq=usfans-cat-jersey-02&orientation=squarish&nocache=true',
  },
  {
    id: 'accessories',
    nameKey: 'categories.accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-sparkling-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimal%20fashion%20accessories%20including%20a%20wristwatch%20sunglasses%20and%20a%20simple%20bracelet%20arranged%20neatly%20on%20a%20clean%20cream%20studio%20background%20with%20soft%20natural%20light%20and%20gentle%20shadow%20editorial%20product%20photography%20high%20detail&width=600&height=600&seq=usfans-cat-accessories-02&orientation=squarish&nocache=true',
  },
  {
    id: 'bags',
    nameKey: 'categories.bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-shopping-bag-line',
    image: 'https://readdy.ai/api/search-image?query=A%20stylish%20neutral%20canvas%20tote%20bag%20and%20a%20small%20leather%20backpack%20displayed%20on%20a%20clean%20light%20beige%20studio%20background%20with%20soft%20natural%20daylight%20and%20gentle%20shadow%20editorial%20minimal%20product%20photography%20high%20detail&width=600&height=600&seq=usfans-cat-bags-01&orientation=squarish',
  },
  {
    id: 'belts',
    nameKey: 'categories.belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-tools-line',
    image: 'https://readdy.ai/api/search-image?query=A%20neatly%20coiled%20brown%20leather%20belt%20with%20a%20simple%20metal%20buckle%20arranged%20on%20a%20clean%20cream%20studio%20surface%20with%20soft%20natural%20light%20and%20subtle%20shadow%20editorial%20minimal%20product%20photography%20high%20detail&width=600&height=600&seq=usfans-cat-belts-01&orientation=squarish',
  },
  {
    id: 'perfumes',
    nameKey: 'categories.perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-star-line',
    image: 'https://readdy.ai/api/search-image?query=A%20single%20elegant%20glass%20perfume%20bottle%20with%20soft%20amber%20liquid%20on%20a%20clean%20white%20studio%20background%20with%20gentle%20natural%20light%20and%20delicate%20shadow%20editorial%20minimal%20beauty%20product%20photography%20high%20detail&width=600&height=600&seq=usfans-cat-perfumes-01&orientation=squarish',
  },
  {
    id: 'other',
    nameKey: 'categories.other',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    image: 'https://readdy.ai/api/search-image?query=A%20small%20curated%20flat%20lay%20of%20assorted%20fashion%20details%20including%20a%20wallet%20keychain%20and%20phone%20case%20arranged%20on%20a%20clean%20light%20cream%20studio%20background%20with%20soft%20natural%20light%20editorial%20minimal%20product%20photography%20high%20detail&width=600&height=600&seq=usfans-cat-other-01&orientation=squarish',
  },
];

export const heroImage =
  'https://readdy.ai/api/search-image?query=A%20bright%20fresh%20minimalist%20flat%20lay%20of%20folded%20casual%20clothing%20sneakers%20hoodies%20caps%20and%20accessories%20arranged%20in%20soft%20neutral%20beige%20sage%20and%20cream%20tones%20with%20warm%20natural%20window%20light%20and%20a%20clean%20light%20background%20editorial%20product%20photography%20high%20detail&width=1600&height=900&seq=usfans-hero-02&orientation=landscape&nocache=true';